import {APP_ID, NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {NgOptimizedImage} from "@angular/common";

import {OverlayModule} from "@angular/cdk/overlay";
import {ScrollingModule} from "@angular/cdk/scrolling";

import {provideHttpClient, withFetch, withInterceptorsFromDi} from "@angular/common/http";

import {AppRoutingModule} from "./app-routing.module";
import {AppComponent} from "./app.component";
import {SharedModule} from "./shared/shared.module";
import {CmsPageModule} from "./shared/components/cms-page/cms-page.module";
import {BusinessDialogModule} from "./shared/components/dialogs/business-dialog/business-dialog.module";

import {environment} from "../environments/environment";

// AngularFire modular (new style)
import {initializeApp, provideFirebaseApp} from "@angular/fire/app";
import {getFirestore, provideFirestore} from "@angular/fire/firestore";
import {getStorage, provideStorage} from "@angular/fire/storage";
import {getAnalytics, provideAnalytics} from "@angular/fire/analytics";

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    OverlayModule,
    ScrollingModule,
    NgOptimizedImage,

    AppRoutingModule,

    SharedModule,
    CmsPageModule,
    BusinessDialogModule,
  ],
  providers: [
    {provide: APP_ID, useValue: "serverApp"},

    // HttpClient (fine)
    provideHttpClient(withInterceptorsFromDi(), withFetch()),

    // Firebase (new style) MUST be in providers, not imports
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),
    provideAnalytics(() => getAnalytics()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
